import { HTTP_TYPES } from '@/lib/enums';
import api from '@/api/api';
import { PLATFORM_HEADERS } from './platform';

// ponytail: base URL is a stub until the real Public/Internal API host is confirmed.
const BASE = import.meta.env.VITE_125_PLATFORM_PUBLIC_BASE_URL;

const response = {
	// GET /feedback — keyset pagination; filters as query params, config as headers.
	async getFeedback(
		params: Record<string, string>,
		headers: Record<string, string>,
	): Promise<any> {
		return await api(
			HTTP_TYPES.GET,
			`${BASE}/feedback`,
			undefined,
			params,
			'application/json',
			'v1',
			{ ...PLATFORM_HEADERS, ...headers },
		);
	},
	// GET /feedback/top-comments — fixed-size selection, no pagination. Same seam as
	// getFeedback: filters as query params, company scoping and entitlement as headers.
	async getTopComments(
		params: Record<string, string>,
		headers: Record<string, string>,
	): Promise<any> {
		return await api(
			HTTP_TYPES.GET,
			`${BASE}/feedback/top-comments`,
			undefined,
			params,
			'application/json',
			'v1',
			{ ...PLATFORM_HEADERS, ...headers },
		);
	},
};

export default response;
